import React, { useEffect, useState} from 'react';
import './Login.css';
import logo2 from '../../images/Login/logo2.svg';
import Loading from '../Misc/Other/Loading';
import RingLoader from "react-spinners/RingLoader";
function Login() {
    const [loaded, setLoaded] = useState(true);
    const [loadedButton, setLoadedButton] = useState(true);
    var [credenciales, setCredenciales] = useState({username: '', password: ''});
    var [mensajeError, setMensajeError] = useState("");
    var [botonInicioSesion, setBotonInicioSesion] = useState(<></>);

    //Registrar los cambios en las casillas de nombre y contraseña
    const handleInputChange = (event) => {
        setCredenciales({
            ...credenciales,
            [event.target.name]: event.target.value
        });
    }

    //Enviar las credenciales a las apis
    const headers = credenciales;
    const enviarDatos = (event) => {
        setLoadedButton(false);
        event.preventDefault();
        fetch( window.location.protocol+"//"+window.location.hostname+"/api" + '/sessions/login', {
        method: 'POST',
        credentials: 'include',
        headers:{
            'username': headers.username,
            'password': headers.password
        }
        })
        .then(response => {/*Recogemos todos los datos estáticos y los guardamos en Session Storage*/
            if(response.status === 200){//Si son correctas las credenciales, recogemos los datos
                setMensajeError("");
                var x = document.getElementById("error_message");
                x.style.display = "none";
                let variables = '';
                let idParque = 0;
                fetch( window.location.protocol+"//"+window.location.hostname+"/api" + '/frontEnd/configuration', {method: 'GET',credentials: 'include'})
                .then(async(data) => { 
                    setLoaded(false);//Pantalla de carga
                    sessionStorage.setItem("configuration",JSON.stringify(await data.json()));
                    idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
                    console.log(idParque)
                    
                    if(!sessionStorage.getItem('ScreenConfiguration')){
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/frontEnd/scadaScreensConfiguration", { method: 'GET', credentials: 'include' })
                        .then( async(dataScreen) => { sessionStorage.setItem('ScreenConfiguration', JSON.stringify(await dataScreen.json()));})
                        .catch(e => {console.log(e);});
                    }
                    if(!sessionStorage.getItem('Legend')) {
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/frontEnd/statusLegend", { method: 'GET', credentials: 'include' })
                        .then( async(dataLege) => { sessionStorage.setItem('Legend',JSON.stringify(await dataLege.json()));})
                        .catch(e => {console.log(e);})
                    }
                    if(!sessionStorage.getItem('CTConfiguration')) {
                        variables = '&variables=id,idCT,idDevice,idSolarFarm,name,alias,coordX,coordY';
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/CTs?idSolarFarm="+idParque+variables, { method: 'GET', credentials: 'include' })
                        .then( async(dataCT) => {sessionStorage.setItem('CTConfiguration', JSON.stringify(await dataCT.json()));})
                        .catch(e => {console.log(e);});
                    }
                    if(!sessionStorage.getItem('InverterConfiguration')) {
                    variables = '&variables=id,idSolarFarm,idCT,idDevice,idInverter,name,description,coordX,coordY,nominalPower,peakPower,mpptNumber,stringNumber';
                    fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/inverters?idSolarFarm="+idParque+variables, { method: 'GET', credentials: 'include' })
                    .then( async(dataInverter) => { sessionStorage.setItem('InverterConfiguration', JSON.stringify(await dataInverter.json()));})
                    .catch(e => {console.log(e);});
                    }
                    if(!sessionStorage.getItem('TrackerConfiguration')) {
                        variables = '&variables=id,idSolarFarm,idCT,idInverter,idDevice,idTracker,name,coordX,coordY';
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/trackers?idSolarFarm="+idParque+variables, { method: 'GET', credentials: 'include' })
                        .then( async(dataTracker) => { sessionStorage.setItem('TrackerConfiguration', JSON.stringify(await dataTracker.json()));})
                        .catch(e => {console.log(e);});
                    }
                    if(!sessionStorage.getItem('MeteoConfiguration')) {
                        variables = '&variables=id,idSolarFarm,idDevice,idMS,name,coordX,coordY';
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/meteorologicalStation?idSolarFarm="+idParque+variables, { method: 'GET', credentials: 'include' })
                        .then( async(dataMeteo) => { sessionStorage.setItem('MeteoConfiguration', JSON.stringify(await dataMeteo.json()));})
                        .catch(e => {console.log(e);});
                    }
                    
                    if(!sessionStorage.getItem('NCUConfiguration')) {
                        variables = '&variables=id,idSolarFarm,idDevice,idNCU,nameNCU,coordX,coordY';
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/NCU?idSolarFarm="+idParque+variables, { method: 'GET', credentials: 'include' })
                        .then( async(dataNCU) => { sessionStorage.setItem('NCUConfiguration', JSON.stringify(await dataNCU.json()));})
                        .catch(e => {console.log(e);});
                    }
                    
                    if(!sessionStorage.getItem('NCUGroups')) {
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/frontEnd/NCUGroups", { method: 'GET', credentials: 'include' })
                        .then( async(dataNCUG) => { sessionStorage.setItem('NCUGroups',JSON.stringify(await dataNCUG.json()));})
                        .catch(e => {console.log(e);})
                    }
                 
                    if(!sessionStorage.getItem('commands')) {
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/frontEnd/commands", { method: 'GET', credentials: 'include' })
                        .then( async(dataCommands) => { sessionStorage.setItem('commands',JSON.stringify(await dataCommands.json()));})
                        .catch(e => {console.log(e);})
                    }

                    if(!sessionStorage.getItem('ZoneConfiguration')) {
                        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/frontEnd/zones", { method: 'GET', credentials: 'include' })
                        .then( async(dataZone) => { sessionStorage.setItem('ZoneConfiguration', JSON.stringify(await dataZone.json()));})
                        .catch(e => {console.log(e);});
                    }

                    var inter = setInterval(() => {
                        if(sessionStorage.getItem('configuration') && sessionStorage.getItem('Legend') && sessionStorage.getItem('CTConfiguration') &&
                        sessionStorage.getItem('InverterConfiguration') && sessionStorage.getItem('TrackerConfiguration') && sessionStorage.getItem('MeteoConfiguration') &&
                        sessionStorage.getItem('NCUConfiguration') && sessionStorage.getItem('ZoneConfiguration') && sessionStorage.getItem('ScreenConfiguration') && 
                        sessionStorage.getItem('NCUGroups') && sessionStorage.getItem('commands')) {    
                            window.open("/", "_self");
                            clearInterval(inter);
                        }
                    });
                    });
            }else if(response.status === 401 || response.status === 400){//Las credenciales están mal
                setMensajeError("Las credenciales no son correctas.");
                var x = document.getElementById("error_message");
                x.style.display = "block";
                setLoadedButton(true);
            }else if(response.status === 502){//Problemas de conexion con la API
                setMensajeError("No hay conexión con la API del SCADA. Contacte con un administrador.");
                var x = document.getElementById("error_message");
                x.style.display = "block";
                setLoadedButton(true);
            }else{//Timeout o otros errores
                setMensajeError("Ha ocurrido un error inesperado. Contacte con un administrador.");
                var x = document.getElementById("error_message");
                x.style.display = "block";
                setLoadedButton(true);
            }
            })
        .catch(e => { 
                setMensajeError("No hay conexión con la API del SCADA. Contacte con un administrador.");
                var x = document.getElementById("error_message");
                x.style.display = "block";
                console.error(e);
                setLoadedButton(true);
            })
    }


useEffect(()=>{
    var htmlBotSesion;

    if(credenciales.name ==='' || credenciales.password ===''){
        htmlBotSesion = <button type="submit" className="btn btn-primary" disabled>Iniciar Sesión</button>
    }else{
        if (loadedButton === true) {
            htmlBotSesion = <button type="submit" className="btn btn-primary">Iniciar Sesión</button>
        } else {
            htmlBotSesion = 
            <button type="submit" className="btn btn-primary" style={{paddingLeft:"46%"}}>
                <RingLoader color="rgb(255, 255, 255)" size={30}/>
            </button>
        }
    }

    
    setBotonInicioSesion(htmlBotSesion);
},[loadedButton,credenciales])


    if(loaded === false){
        return(<><Loading/></>)
    }else{
        return(
            <div className="div-form-login">
                <form className="form-login" onSubmit={enviarDatos}>
                    <div className="form-content">
                        <img className="form-title" src={logo2} alt="Logo" />
                        <div className="form-group mt-3">
                            <label>Usuario</label>
                            <input
                                type="text"
                                className="form-control mt-1"
                                placeholder="Introducir usuario"
                                name="username"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                className="form-control mt-1"
                                placeholder="Introducir contraseña"
                                name="password"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div id="error_message" className="alert alert-danger" role="alert" style={{ display: "none",marginTop:"1rem" }}>
                            {mensajeError}
                        </div>
                        <div className="d-grid gap-2 mt-3">
                            {botonInicioSesion}
                        </div>
                        
                    </div>
                </form>
            </div>
        )  
    }

    
}

export default Login